import { ImagePreview, ImageContainer, ImageDetails } from "../styles";
import { useBoolState } from "@dvrt/react-tools";
import { useState } from "react";
import { formatBytes } from "../tools";
import { Dialog } from "@mui/material";
import { FileMessageContent } from "../../../types";

const ImagePreviewContent = ({ content }: { content: FileMessageContent }) => {
    const [isShow, show, hide] = useBoolState();
    const [imageSize, setImageSize] = useState<{ w: number; h: number }>();

    return (
        <>
            <ImagePreview onClick={show} src={window.chattoBaseUrl + content.preview_url} alt="preview" />
            <Dialog open={isShow} onClose={hide} maxWidth="md">
                <ImageContainer>
                    <img
                        src={window.chattoBaseUrl + content.file_url}
                        style={{ width: "100%", display: "block" }}
                        onLoad={(event) => {
                            setImageSize({
                                w: event.currentTarget.naturalWidth,
                                h: event.currentTarget.naturalHeight,
                            });
                        }}
                        alt="fullsize"
                    />
                    <ImageDetails>
                        {content.filename} ({formatBytes(content.metadata.size)}) ({imageSize?.w}x{imageSize?.h})
                    </ImageDetails>
                </ImageContainer>
            </Dialog>
        </>
    );
};

export default ImagePreviewContent;
